import { c as _c } from "react/compiler-runtime";
import { MouseEventHandler, PointerEventHandler, ReactNode } from "react";
interface CustomButtonProps {
  children: ReactNode;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  ariaLabel?: string;
  ariaBusy?: boolean;
  /** 숨겨진 고정 바 안의 버튼을 탭 순서에서 빼는 용도(-1). aria-hidden 영역에 포커스가 남지 않게 한다. */
  tabIndex?: number;
  /** 예: 자동완성 항목에서 입력 blur가 click보다 먼저 오는 것 방지 */
  onMouseDown?: MouseEventHandler<HTMLButtonElement>;
  onPointerDown?: PointerEventHandler<HTMLButtonElement>;
}
const CustomButton = t0 => {
  const $ = _c(11);
  const {
    children,
    onClick,
    className,
    disabled,
    type: t1,
    ariaLabel,
    ariaBusy,
    tabIndex,
    onMouseDown,
    onPointerDown
  } = t0;
  const type = t1 === undefined ? "button" : t1;
  let t2;
  if ($[0] !== ariaBusy || $[1] !== ariaLabel || $[2] !== children || $[3] !== className || $[4] !== disabled || $[5] !== onClick || $[6] !== onMouseDown || $[7] !== onPointerDown || $[8] !== tabIndex || $[9] !== type) {
    t2 = <button className={className} disabled={disabled} tabIndex={tabIndex} type={type} onClick={onClick} aria-label={ariaLabel} aria-busy={ariaBusy} onMouseDown={onMouseDown} onPointerDown={onPointerDown}>{children}</button>;
    $[0] = ariaBusy;
    $[1] = ariaLabel;
    $[2] = children;
    $[3] = className;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = onMouseDown;
    $[7] = onPointerDown;
    $[8] = tabIndex;
    $[9] = type;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default CustomButton;